export const rmrNames = {
  DOORPRO: 'Doorpro',
  PREMIUMVIDEO_ANALYTICS: 'PremiumVideo Analytics',
  PREMIUMVIDEO: 'PremiumVideo 4',
  PREMIUM_VIDEO: 'Premium Video',
  FIVE_TO_EIGHT_CAMERA_ADDER:'5 to 8 Camera Adder',
  NINE_TO_TWELVE_CAMERA_ADDER:'9 to 12 Camera Adder',
  TWO_WAY_VOICE: '2-Way Voice',
};
